import axios from "axios";
import { Message } from "element-ui";
import router from "../router";
import qs from 'qs';
import store from '../store';


axios.defaults.transformRequest = [function (data) {
	if((typeof data == 'string') && data.includes('configValue')){
		return data
	}else{
		let ret = ''
		for (let it in data) {
		  ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
		}
		return ret
	}
}]
// 创建axios实例
const service = axios.create({
  // api的base_url
  // baseURL: process.env.VUE_APP_URL, // 本地-后端解决跨域后
  // baseURL: "https://ymsh88.cn/api", // 本地-前端解决跨域
  baseURL: "https://mx.ymsh88.cn/api", // 本地-前端解决跨域
  timeout: 15000 // 请求超时时间
});

// request 请求拦截器
service.interceptors.request.use(
  config => {
    //设置header
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
	config.method = 'post'
    // 格式化 get 请求
    if (config.isJson) {
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    }
    // 让每个请求携带自定义token 
		let token = store.state.userToken || window.localStorage.getItem('token')
    if (token) {
      // header添加token
      config.headers["token"] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// respone 响应拦截器
service.interceptors.response.use(
  response => {
		if (!response.data.success) {
				if (response.data.code == -1001) {
					console.log('2222')
					Message({
							message: "用户未登录",
							center: true
						});
						router.push("/login");
					return;
				}	
				if(response.request.responseURL.includes('export')){
					return response;
				}
				Message({
					message: response.data.info,
					center: true
				});
				
		  return;
		}
    return response.data;
  },
  error => {
	  // if (error.response.code == -1001) {
		 //  console.log('2222')
	  //   Message({
	  //       message: "用户未登录",
	  //       center: true
	  //     });
	  //     router.push("/login");
	  //   return;
	  // }
    // if (error.response.status == 400) {
    //   Message({
    //     message: "参数信息有误",
    //     center: true
    //   });
    //   return;
    // } else if (error.response.status == 302) {
    //   Message({
    //     message: "用户未登录",
    //     center: true
    //   });
    //   router.push("/login");
    //   return;
    // } else if (error.response.status == 404) {
    //   Message({
    //     message: "连接失败",
    //     center: true
    //   });
    //   return;
    // } else if (error.response.status == 500) {
    //   Message({
    //     message: "服务器内部错误",
    //     center: true
    //   });
    //   return;
    // } else if (error.response.status == 560) {
    //   Message({
    //     message: "数据库异常",
    //     center: true
    //   });
    //   return;
    // }
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000
    // });
    return Promise.reject(error);
  }
);

export default service;
